module.exports = __webpack_public_path__ + "static/media/icon_buildings.4e988582.svg";